import * as React from "react";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import clsx from "clsx";
import MenuIcon from "@material-ui/icons/Menu";
import { useStyles } from "./Header.styles";
import { HeaderMenu } from "./HeaderMenu/HeaderMenu";

interface HeaderProps {
  open: boolean;
  onDrawerOpen: () => void;
}

export function Header({ open, onDrawerOpen }: HeaderProps) {
  const classes = useStyles();

  return (
    <AppBar position="absolute" className={clsx(classes.header, open && classes.headerShift)}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={onDrawerOpen}
          className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
        >
          <MenuIcon />
        </IconButton>
        <Typography component="h1" variant="h5" color="inherit" noWrap className={classes.title}>
          MindSet
        </Typography>
        <HeaderMenu />
      </Toolbar>
    </AppBar>
  );
}
